import api from '../../../store/api';
import {unwrapData} from '../../../store/apiResponse';
import type {ConfigResponse} from '../../../services/chatServiceTypes';
import type {TenantFeature} from './rtcFeatureFlags';

export const rtcFeaturesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getTenantRtcFeatures: builder.query<readonly TenantFeature[], void>({
            query: () => ({
                url: '/api/v1/features/enabled',
                method: 'GET',
            }),
            transformResponse: (response: ConfigResponse) => unwrapData(response) ?? [],
        }),
    }),
});

export const {useGetTenantRtcFeaturesQuery} = rtcFeaturesApi;
